import {Component, OnInit} from '@angular/core';
import {
    BmCustomerBillingAccountTransactionObjectBaseComponent
} from "../bm-customer-billing-account-transaction-object-base.component";


@Component({
    selector: 'bm-customer-billing-account-transaction-object-component-full',
    templateUrl: 'bm-customer-billing-account-transaction-object-full.component.html',
    standalone: false
})
export class BmCustomerBillingAccountTransactionObjectFullComponent extends BmCustomerBillingAccountTransactionObjectBaseComponent implements OnInit {


    /**
     * On Object Change. When object is retrieved
     */
    ngOnInit() {
        super.ngOnInit();
    }


}
